import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { parentTexts } from 'consts/text';
import { getFormattedPrice } from 'utils/getFormattedPrice';
import { SummaryText } from '../../../../../atoms/SummaryText/SummaryText';
import { ArrowButton } from '../../../../../molecules/DatePickerWithArrows/DatePickerWithArrows.styled';
import { StyledRow } from './ChildrenBillAdditionalRightTableHeaderComponent.styled';

type ChildrenBillAdditionalRightTableHeaderProps = {
    diff?: number;
    isExpanded?: boolean;
    onExpand?: () => void;
    summary: number;
};

export const ChildrenBillAdditionalRightTableHeaderComponent = ({
    diff,
    summary,
    isExpanded,
    onExpand,
}: ChildrenBillAdditionalRightTableHeaderProps) => {
    return (
        <StyledRow align="middle">
            {diff === undefined ? (
                <SummaryText
                    mainTitle={parentTexts.settlement.summary}
                    mainValue={getFormattedPrice(summary)}
                />
            ) : (
                <SummaryText
                    mainTitle={parentTexts.settlement.summary}
                    mainValue={getFormattedPrice(summary)}
                    subtitle={parentTexts.settlement.diff}
                    subtitleValue={getFormattedPrice(diff)}
                    subtitle2={parentTexts.settlement.beforeCorrection}
                    subtitleValue2={getFormattedPrice(summary - diff)}
                />
            )}
            <ArrowButton
                icon={isExpanded ? <IconChevronUp size={20} /> : <IconChevronDown size={20} />}
                onClick={onExpand}
            />
        </StyledRow>
    );
};
